module.exports = __webpack_public_path__ + "static/media/4.7a175186.jpg";